import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Turn an API error (axios) into a message that tells the user what to correct
export function apiErrorMessage(err, fallback = 'Something went wrong') {
  const data = err?.response?.data;
  if (!data) return err?.message && !err.response ? `Network error — ${err.message}` : fallback;
  if (Array.isArray(data.errors) && data.errors.length) return data.errors.join('\n');
  const d = data.detail;
  if (typeof d === 'string' && d) return d;
  if (Array.isArray(d)) {
    return d.map(e => {
      if (typeof e === 'string') return e;
      const loc = (e.loc || []).filter(p => p !== 'body').join(' → ');
      return loc ? `${loc}: ${e.msg}` : e.msg;
    }).join('\n');
  }
  if (data.message) return data.message;
  return fallback;
}

export function toastApiError(toast, err, title) {
  const msg = apiErrorMessage(err, title);
  if (msg === title) toast.error(title);
  else toast.error(title, { description: msg, duration: 9000, style: { whiteSpace: 'pre-line' } });
  highlightErrorFields(err?.response?.data?.fields);
}

// Outline inputs marked with data-field="<path>" (e.g. "name", "stops.1.facility_id") in red until edited
export function highlightErrorFields(paths) {
  if (!Array.isArray(paths) || !paths.length) return;
  let first = null;
  paths.forEach(path => {
    const els = document.querySelectorAll(`[data-field="${path}"]`);
    els.forEach(el => {
      el.classList.add('field-error');
      if (!first) first = el;
      const clear = () => { el.classList.remove('field-error'); el.removeEventListener('input', clear); el.removeEventListener('change', clear); el.removeEventListener('click', clear); };
      el.addEventListener('input', clear);
      el.addEventListener('change', clear);
      el.addEventListener('click', clear);
      setTimeout(clear, 20000);
    });
  });
  if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
